import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <header className="bg-black/80 backdrop-blur-sm sticky top-0 z-50">
            <nav className="container mx-auto px-6 py-4 flex justify-between items-center">
                <div className="flex items-center space-x-4">
                    <Link to="/">
                        <img src="/Logo.png" alt="R.A.W. Fitness Logo" className="h-12 w-auto" />
                    </Link>
                </div>
                <div className="hidden md:flex items-center space-x-8">
                    <a href="/#features" className="nav-item font-semibold">Features</a>
                    <a href="/#news" className="nav-item font-semibold">News & Videos</a>
                    <a href="/#calculators" className="nav-item font-semibold">Calculators</a>
                    <a href="/#about" className="nav-item font-semibold">About Us</a>
                    <a href="/#contact" className="nav-item font-semibold">Contact</a>
                </div>
                <div className="hidden md:flex items-center space-x-4">
                    <Link to="/login" className="text-white font-bold py-2 px-4 rounded-lg border-2 border-lime hover:bg-lime hover:text-black transition duration-300">Login</Link>
                    <Link to="/signup" className="text-black font-bold py-2 px-4 rounded-lg bg-magenta hover:bg-opacity-80 transition duration-300 glow-magenta">Sign Up</Link>
                </div>
                {/* Mobile Menu Button */}
                <button id="mobile-menu-button" className="md:hidden text-white" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7"></path></svg>
                </button>
            </nav>
            {/* Mobile Menu */}
            <div id="mobile-menu" className={`${isMenuOpen ? 'block' : 'hidden'} md:hidden px-6 pb-4`}>
                <a href="/#features" className="block py-2 text-center nav-item font-semibold">Features</a>
                <a href="/#news" className="block py-2 text-center nav-item font-semibold">News & Videos</a>
                <a href="/#calculators" className="block py-2 text-center nav-item font-semibold">Calculators</a>
                <a href="/#about" className="block py-2 text-center nav-item font-semibold">About Us</a>
                <a href="/#contact" className="block py-2 text-center nav-item font-semibold">Contact</a>
                 <div className="flex flex-col items-center space-y-4 mt-4">
                    <Link to="/login" className="w-full text-center text-white font-bold py-2 px-4 rounded-lg border-2 border-lime hover:bg-lime hover:text-black transition duration-300">Login</Link>
                    <Link to="/signup" className="w-full text-center text-black font-bold py-2 px-4 rounded-lg bg-magenta hover:bg-opacity-80 transition duration-300 glow-magenta">Sign Up</Link>
                </div>
            </div>
        </header>
    );
}

export default Header;
